import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from '../store/store';
import NoData from '../components/NoData';

interface RestrictedRouteProps {
	permissionKeys: string[];
	children: React.ReactNode;
}

const RestrictedRoute = ({ permissionKeys, children }: RestrictedRouteProps) => {
	const { t } = useTranslation(['common']);
	const permissions: any = useSelector((state: RootState) => state.auth?.permissions);

	const isFullyRestricted =
		permissionKeys.length > 0 && permissionKeys.every((key) => permissions?.[key] === false);

	if (isFullyRestricted) {
		return <NoData text={t('permission_error')} />;
	}

	return <>{children}</>;
};

export default RestrictedRoute;
